import { useState } from "react";
import { getLoggedInUserInfo } from "../../helpers/api_helper";
import { useSelector } from "react-redux";

const useProfile = () => {
  const [userProfile] = useState<any>(getLoggedInUserInfo())
  const [loading] = useState<boolean>(userProfile ? false : true);

  return { userProfile, loading };
};

const useRole = () => {
  const { user } = useSelector((state: any) => state?.Login);
  const userPermissions = user?.admin?.permissions || [];
  return { userPermissions };
};

export { useProfile, useRole };
